/**
 * 班组管理
 */
 import axios from '../request';
 export default{
    

    /**
     * 班组管理
     */
    // 查询班组列表信息
    searchGroupList: params =>
    axios({
        method: 'post',
        url: '/materials/team/findList',
        headers: {
            pageNum: params.pageNum,
            pageSize: params.pageSize
        },
        data:params
    }),
    // 添加或修改班组信息
    insertGroupOrUpdate: params =>
        axios.post('/materials/team/addOrUpdate', params),
    // 班组信息详情
    detailsGroupDevice: params =>
        axios.post('/materials/team/detail', params),
    // 删除班组信息
    deleteGroupDevice: params =>
        axios.post('/materials/team/delete', params),
    //删除班组下的人
    deleteGroupUser: params =>
        axios.post('/materials/team/deleteTeamUser', params),
    //班组管理下拉
    getAllGroupDevice: params =>
        axios.get('/materials/group/', {params}),
    //导出数据
    exportGroupDatas:params=>
        axios({
            method: 'get',
            url: '/materials/team/export`',
            responseType: 'blob',
            params: params
        }),


 }